import { useState,useRef } from "react";
import { useLocation } from "react-router-dom";

export default function CardToCardTransferTXPGAPIJson() {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabSecond, setActiveTabSecond] = useState(3);
  const [activeTabThird, setActiveTabThird] = useState(5);
  const [activeTabFourth, setActiveTabFourth] = useState(7);
  const [activeTabFifth, setActiveTabFifth] = useState(8);
  const [activeTabSix, setActiveTabSix] = useState(10);
  const copyBodyRef = useRef(null);
  const copyBodyRef1 = useRef(null);
  const copyBodyRef2 = useRef(null);
  const copyBodyRef3 = useRef(null);
  const copyBodyRef4 = useRef(null);
  const copyBodyRef5 = useRef(null);
  const [copied, setCopied] = useState(false);

 const handleCopy = (ref) => {
    const text = ref.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    });
  };

   const formHtml =`<form id="formCReq" name="formCReq" action="https://acstest.libertybank.ge" method="post">
          <input type="hidden" id="creq" name="creq"
value="eyJhY3NUcmFuc0lEIjoiYzBjOTMyNTctYjZkYy00NWJlLTgwZGItMDIxYTVjYjE1NzZiIiwidGhyZWVEU1Nlc
nZlclRyYW5zSUQiOiJkM2YzNTBjOC04NGFmLTQ5N2QtYjEyMS04YmRjODQ5MmVmYTgiLCJjaGFsbGVuZ2VXa
W5kb3dTaXplIjoiMDUiLCJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMi4wIn0" />
          </form>`;
  return (
    <>
      <div className="doc-content">
        <h3 className="text-left pb-24 doc-title">Card To Card Transfer via TXPG API</h3>
        <h4 className="pb-16 sub-title flex-items-center">
          <span className="xml-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21.477"
              height="25.499"
              viewBox="0 0 21.477 25.499"
            >
              <g
                id="Type_Code_-_JSON_Style_Default"
                data-name="Type= Code - JSON, Style=Default"
                transform="translate(-1)"
              >
                <path
                  id="Path_6089"
                  data-name="Path 6089"
                  d="M23.516,5.448V22.723a2.026,2.026,0,0,1-2.026,2.026H7.776A2.026,2.026,0,0,1,5.75,22.723V2.776A2.026,2.026,0,0,1,7.776.75H18.4Z"
                  transform="translate(-1.789)"
                  fill="none"
                  stroke="#d0d5dd"
                  stroke-width="1.5"
                />
                <path
                  id="Path_6090"
                  data-name="Path 6090"
                  d="M24.623,1h0Zm5.3,5.922H25.247A1.247,1.247,0,0,1,24,5.675h5.922Zm-4.675,0A1.247,1.247,0,0,1,24,5.675V1h1.247V6.922ZM29.922,1V1Z"
                  transform="translate(-8.663 -0.094)"
                  fill="#d0d5dd"
                />
                <rect
                  id="Rectangle_2269"
                  data-name="Rectangle 2269"
                  width="19.947"
                  height="8.104"
                  rx="2"
                  transform="translate(1 12.75)"
                  fill="#2d3282"
                />
                <path
                  id="Path_6091"
                  data-name="Path 6091"
                  d="M6.57,22.942v2.98a1.4,1.4,0,0,1-.393,1.066,1.442,1.442,0,0,1-1.047.374,1.554,1.554,0,0,1-1.11-.393A1.457,1.457,0,0,1,3.6,25.853h1.06a.667.667,0,0,0,.112.418.4.4,0,0,0,.324.137.371.371,0,0,0,.3-.125.544.544,0,0,0,.106-.362v-2.98Zm2.444,4.42a2.251,2.251,0,0,1-.86-.156,1.424,1.424,0,0,1-.611-.461,1.273,1.273,0,0,1-.237-.736H8.441a.563.563,0,0,0,.168.374.55.55,0,0,0,.374.125.6.6,0,0,0,.374-.106.374.374,0,0,0,.137-.305.353.353,0,0,0-.112-.268.831.831,0,0,0-.268-.175,4.045,4.045,0,0,0-.449-.156,4.923,4.923,0,0,1-.692-.262,1.279,1.279,0,0,1-.461-.386,1.077,1.077,0,0,1-.193-.667,1.138,1.138,0,0,1,.443-.954,1.808,1.808,0,0,1,1.153-.349,1.828,1.828,0,0,1,1.166.349,1.229,1.229,0,0,1,.474.96H9.4a.44.44,0,0,0-.156-.33.54.54,0,0,0-.368-.125.45.45,0,0,0-.312.106.362.362,0,0,0-.118.293.367.367,0,0,0,.2.33,3.272,3.272,0,0,0,.623.256,5.547,5.547,0,0,1,.686.274,1.3,1.3,0,0,1,.461.38,1.018,1.018,0,0,1,.193.642,1.245,1.245,0,0,1-.193.679,1.309,1.309,0,0,1-.549.486A1.889,1.889,0,0,1,9.014,27.362Zm4.321,0a2.3,2.3,0,0,1-1.135-.287,2.18,2.18,0,0,1-.817-.8,2.274,2.274,0,0,1-.3-1.159,2.24,2.24,0,0,1,.3-1.153,2.18,2.18,0,0,1,.817-.8,2.3,2.3,0,0,1,1.135-.287,2.266,2.266,0,0,1,1.128.287,2.078,2.078,0,0,1,.81.8,2.24,2.24,0,0,1,.3,1.153,2.274,2.274,0,0,1-.3,1.159,2.134,2.134,0,0,1-.81.8A2.266,2.266,0,0,1,13.336,27.362Zm0-.972a1.064,1.064,0,0,0,.835-.349,1.317,1.317,0,0,0,.318-.923,1.3,1.3,0,0,0-.318-.923,1.064,1.064,0,0,0-.835-.349,1.1,1.1,0,0,0-.848.343,1.328,1.328,0,0,0-.312.929,1.342,1.342,0,0,0,.312.929A1.1,1.1,0,0,0,13.336,26.39Zm6.746.929H19.015l-1.783-2.7v2.7H16.167V22.942h1.066l1.783,2.712V22.942h1.066Z"
                  transform="translate(-0.98 -8.335)"
                  fill="#fff"
                />
              </g>
            </svg>
          </span>
          <span className="pl-12"> JSON</span>
        </h4>
        <p className="text-in mb-24 black">Creating Single-Transfer Order</p>
         
        <h3 className="black text-in mb-12 bold">To use this functionality, the merchant must have PCI compliance  </h3>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href=" https://libertypaytxtest.lb.ge:6444/order?terminalid=241"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6444/order?terminalid=241
          </a>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>terminalid – Merchant Id.</span>
        </div>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of Authorization Header:</p>
          <a
            href="#"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            Authorization: Basic VGVybWluYWxTeXMvSUFQMlBUUkFOU0ZFUjoxMjNpb3BJT1Aj
          </a>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTab === 1 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(1)}
              >
                Request
              </div>
              <div
                className={activeTab === 2 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(2)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 1 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                 
                    <pre
                      ref={copyBodyRef}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"typeRid"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Single-Transfer"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"language"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ka"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"amount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"25.00"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"currency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEL"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"hppRedirectUrl"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://bank.com"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"description"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Lololo"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'},'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"dstToken"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"card"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"panBlock"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"data"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"4125706004381848"</span>
                           <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"entryMode"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ECommerce"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        
                      </code>
                    </pre>
                   
                  </div>
                </div>
                 <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">typeRid</span>
                      <span>- Order type.</span>
                    </p>
                    <p>
                      <span className="tag">Language</span>
                      <span>- Language.</span>
                    </p>
                    <p>
                      <span className="tag">amount</span>
                      <span>
                        – Amount . 
                      </span>
                    </p>
                    <p>
                      <span className="tag">currency</span>
                      <span>– Currency.</span>
                    </p>
                    <p>
                      <span className="tag">description</span>
                      <span>
                        - Additional info
                      </span>
                    </p>
                    <p>
                      <span className="tag">hppRedirectUrl</span>
                      <span>
                        – redirect url

                      </span>
                    </p>
                    <p>
                      <span className="tag">dstToken</span>
                      <span>
                        – Destination Card for transaction transfer

                      </span>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre  ref={copyBodyRef} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">9574</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"htpUrl"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://libertypaytxtest.lb.ge/twpga"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"password"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"3g5udgtebyez"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"cvv2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Required"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">id</span>
                      <span>- identifier of the created order. It should be passed in all requests related to the order.</span>
                    </p>
                    <p>
                      <span className="tag">status</span>
                      <span>- status of the order.</span>
                    </p>
                    <p>
                      <span className="tag">password</span>
                      <span>
                        – password of the order.
                      </span>
                    </p>
                    <p>
                      <span className="tag">hppUrl</span>
                      <span>– payment page url if not provided use <a className="link" href="https://libertypaytxtest.lb.ge/twpga" target="_blank">
                     https://libertypaytxtest.lb.ge/twpga
                      </a></span>
                    </p>
                    <p>
                      <span className="tag">cvv2AuthStatus</span>
                      <span>
                        - cvv authorization status

                      </span>
                    </p>                   
                  </div>
                </div>
              </>
            )}{" "}
          </div>
        </div>


        {/* Creating Source Token: */}
        <h5 className="step-title">Creating Source Token:</h5>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order/9574/set-src-token?password=3g5udgtebyez"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6444/order/9574/set-src-token?password=3g5udgtebyez
          </a>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>order - Order Id.</span><br/>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>password - Session Id or password.</span><br/>
        </div>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of Authorization Header:</p>
          <span
           className="link fnt-14  pl-8"
          >
            Authorization: Basic VGVybWluYWxTeXMvSUFQMlBUUkFOU0ZFUjoxMjNpb3BJT1Aj
          </span>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabSecond === 3 ? "active-tab" : "tab"}
                onClick={() => setActiveTabSecond(3)}
              >
                Request
              </div>
              <div
                className={activeTabSecond === 4 ? "active-tab" : "tab"}
                onClick={() => setActiveTabSecond(4)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef1)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabSecond === 3 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                 
                    <pre
                      ref={copyBodyRef1}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                     <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"token"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"card"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"panBlock"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token">"data"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"5324343004638435"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token">"entryMode"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ECommerce"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token">"expiration"</span>
                          <span className="token operatorexpiration">{':'}</span>
                          <span className="token property">"1124"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                      </code>
                    </pre>
                   
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">token</span>
                      <span>- Source Card for transaction transfer.</span>
                    </p>
                    <p>
                      <span className="tag">Data</span>
                      <span>- Card Pan number</span>
                    </p>
                    <p>
                      <span className="tag">expiration</span>
                      <span>
                        – Expiration Data.
                      </span>
                    </p>
                    <p>
                      <span className="tag">entryMode</span>
                      <span>– EntryMode Type.</span>
                    </p>
                                  
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre  ref={copyBodyRef1} style={{ whiteSpace: "pre-wrap" }}>
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"order"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"cvv2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Required"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"tdsV1AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IneligibleOrder"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"tdsV2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Required"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"otpAutStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"NotSupportedIss"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"srcToken"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"7004"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"paymentMethod"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Card"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"role"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Src"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Active"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"regTime"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2024-02-21 14:41:07"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"displayName"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"532434******8435"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"card"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"expiration"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1124"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"brand"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Mastercard"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"currency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEL"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"country"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"GEO"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token ">"tdsData"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"aReq"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSServerTransID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"d3f350c8-84af-497d-b121-8bdc8492efa8"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"messageType"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"AReq"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"messageVersion"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2.2.0"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSCompInd"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"U"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSRequestorAuthenticationInd"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"01"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSRequestorID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IA00007A"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSRequestorName"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IATRANSFER"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSRequestorURL"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://libertybank.ge/"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSServerOperatorID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"DSRefNum1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSServerRefNumber"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"DSRefNum1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSServerURL"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://3dstestsrv.libertypay.ge:9844"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"acquirerBIN"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"LB_Terminal"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"acquirerMerchantID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"777777"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>

                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"cardExpiryDate"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2411"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"deviceChannel"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"02"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"mcc"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2842"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                                               
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"merchantCountryCode"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"268"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"merchantName"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IATRANSFER"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"messageCategory"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"01"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"purchaseAmount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2500"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"purchaseCurrency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"981"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"purchaseExponent"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"purchaseDate"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"20240221104048"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>


                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                      </code>
                    </pre>
                  </div>
                </div>
               
               
              </>
            )}{" "}
          </div>
        </div>






        {/* Next Merchant makes AREQ Request: */}
        <h5 className="step-title">Next Merchant makes AREQ Request:</h5>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order/9569/tds-areq?password=1m77s8jnhff86"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6444/order/9569/tds-areq?password=1m77s8jnhff86
          </a>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>order - Order Id.</span><br/>
          </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>password - Session Id or password.</span><br/>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>threeDSServerTransID – Id that came with create source token response.</span><br/>
        </div>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of Authorization Header:</p>
          <a
            href="#"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            Authorization: Basic VGVybWluYWxTeXMvSUEwMDAxMDE6MTIzaW9wSU9QIw==
          </a>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabThird === 5 ? "active-tab" : "tab"}
                onClick={() => setActiveTabThird(5)}
              >
                Request
              </div>
              <div
                className={activeTabThird === 6 ? "active-tab" : "tab"}
                onClick={() => setActiveTabThird(6)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef2)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabThird === 5 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                 
                    <pre
                      ref={copyBodyRef2}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"aReq"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSServerTransID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"d3f350c8-84af-497d-b121-8bdc8492efa8"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"messageType"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"AReq"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"messageVersion"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2.2.0"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSCompInd"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"U"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSRequestorAuthenticationInd"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"01"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSRequestorID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IA00GPI"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"threeDSRequestorName"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IATRANSFER"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSRequestorURL"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://libertybank.ge/"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSServerOperatorID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"DSRefNum"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSServerRefNumber"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"DSRefNum"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"threeDSServerURL"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://3dstestsrv.libertypay.ge:9744"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acquirerBIN"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"LB_Terminal"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acquirerMerchantID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"777777"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"cardExpiryDate"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2411"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"deviceChannel"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"02"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"mcc"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2842"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"merchantCountryCode"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"268"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"merchantName"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"IATRANSFER"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"messageCategory"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"01"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"purchaseAmount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2500"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"purchaseCurrency"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"981"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"purchaseExponent"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"purchaseDate"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"20240221104048"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"transType"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"01"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserAcceptHeader"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"application/json,application/jose;charset=utf-8"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserIP"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"127.0.0.1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserJavaEnabled"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserJavascriptEnabled"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserLanguage"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Ru-ru"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserColorDepth"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"32"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserScreenHeight"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"800"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserScreenWidth"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"1024"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserTZ"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"-300"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"browserUserAgent"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"chrome"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"notificationURL"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"http://test.com/return"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                      </code>
                    </pre>
                   
                  </div>
                </div>
                
              </>
            ) : (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                     <pre
                      ref={copyBodyRef2}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"aRes"</span>
                          <span className="token operator operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token">"threeDSServerTransID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"d3f350c8-84af-497d-b121-8bdc8492efa8"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"dsReferenceNumber"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"DSRefNum"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"dsTransID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"3c699b01-0403-4b58-b9d6-d6c5170ebf1a"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"messageExtension"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'['}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">      </span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"name"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"MesExt1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"id"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ID1"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"criticalityIndicator"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">false</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"data"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">           </span>
                          <span className="token ">"valueOne"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"value"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{']'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"messageType"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ARes"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"messageVersion"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"2.2.0"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acsChallengeMandated"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"N"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acsOperatorID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"10055116"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acsReferenceNumber"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"3DS_LOA_ACS_COPL_020200_00327"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acsTransID"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"c0c93257-b6dc-45be-80db-021a5cb1576b"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"acsURL"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"https://acstest.libertybank.ge"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"authenticationType"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"02"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"transStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"C"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <span className="token punctuation">{','}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token ">"challengeRequired"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">true</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token ">"cReq"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token ">"eyJhY3NUcmFuc0lEIjoiYzBjOTMyNTctYjZkYy00NWJlLTgwZGItMDIxYTVjYjE1NzZiIiwidGhyZWVEU1Nl
cnZlclRyYW5zSUQiOiJkM2YzNTBjOC04NGFmLTQ5N2QtYjEyMS04YmRjODQ5MmVmYTgiLCJjaGFsbG
VuZ2VXaW5kb3dTaXplIjoiMDUiLCJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMi4
wIn0"</span>
                          <span className="token punctuation">{','}</span>  
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token ">"order"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"tdsV2AuthStatus"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"ChallengeInProgress"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"status"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Preparing"</span>
                           <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                      </code>
                    </pre>
                  </div>
                  
                </div>
                
              </>
            )}
            <div className="other-hint" style={{paddingTop:'0'}}>
          <p className="pt-12">From this response Merchant takes cReq, opens Iframe in clients browser and sends POST request with creq
inside form</p>
          <p className="pt-12 ">
            <span className="link">  {formHtml}</span> 
          </p>
          <p className="pt-12">ACS page is opening iside Iframe. Clients enters OTP, then ACS sends POST response to the notificationURL
which we sent in Areq step:</p>
       <p className="pt-12">Inside that POST response there will be cres  </p>
        <p className="link">cres = eyJ0aHJlZURTU2VydmVyVHJhbnNJRCI6ImNiYTkyYTRiLWRmOTQtNDhkMC04NGY3LTlmYjE2ZTE3MTVk
NCIsImFjc1RyYW5zSUQiOiJjYWYxNTAxMi1iMjI2LTRiZDQtYTIyZC0wMzcxMjA3Y2IyMWIiLCJtZXNzYWdlVHlwZ
SI6IkNSZXMiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMS4wIiwidHJhbnNTdGF0dXMiOiJZIn0</p>
        <p className="pt-12">After obtaining cres, merchant proceeds to the final step.</p>
         </div>
          </div>
        </div>



             {/* EXEC Tran: */}
        <h5 className="step-title">EXEC Tran:</h5>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6444/order/1810/exec-tran?password=1jtdfr528wm3p"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6444/order/1810/exec-tran?password=1jtdfr528wm3p
          </a>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>order - Order Id.</span><br/>
        </div>
        <div className="sub-link flex-items-center pb-12">
          <p className="black">Where: </p>
          <span>password - Session Id or password.</span><br/>
        </div>
         <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of Authorization Header:</p>
          <span
            className="link fnt-14  pl-8" >
            Authorization: Basic VGVybWluYWxTeXMvSUEwMDAxMDE6MTIzaW9wSU9QIw==
          </span>
        </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabFourth === 7 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFourth(7)}
              >
                Request
              </div>
              <div
                className={activeTabFourth === 8 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFourth(8)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef3)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabFourth === 7 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef3}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"tran"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"phase"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"Single"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"amount"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"25.00"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"authentication"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"cvv2Block"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"data"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"007"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                      </code>
                    </pre>    
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">data</span>
                      <span>- cvv.</span>
                    </p>
                  </div>
                </div>
               </>
            ) : (
              <>
              <div className="code-ceontent">
                  <div className="code-body">
                    <pre
                      ref={copyBodyRef3}
                      tabIndex="0"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <code >
                        <span className="token-line">
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token head">"tran"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">     </span>
                          <span className="token ">"approvalCode"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"384449"</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token ">"match"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token punctuation">{'{'}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"tranActionId"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"230424-10054137-000hlp="</span>
                          <span className="token punctuation">{','}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">         </span>
                          <span className="token ">"ridByPmo"</span>
                          <span className="token operator">{':'}</span>
                          <span className="token property">"322615867"</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">       </span>
                          <span className="token punctuation">{'}'}</span>
                          <br />
                        </span>
                        
                         <span className="token-line">
                          <span className="token plain">   </span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="token punctuation">{'}'}</span>
                           <br />
                        </span>
                      </code>
                    </pre>    
                  </div>
                </div>
              </>
            )}{" "}
          </div>

       </div>
      </div>
    </>
  );
}
